import React from "react";
import {
  Box,
  Card,
  CardContent,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import * as qs from "../qs";
import * as api from "../services/api";
import * as p from "../parser";
import { useLoaderData } from "react-router";
import { TablePagination } from "../components/table";
import * as f from "../utils/formatter";
import * as d from "shared/src/date.mjs";
import { ChangedFields, RowData } from "../components/history";

const defaults = [
  [["page", "limit"], 25],
  [["page", "offset"], 0],
];

const parsers = [
  [["page", "limit"], (val) => p.parseInt(val, 10)],
  [["page", "offset"], (val) => p.parseInt(val, 0)],
];

function graphqlArgs(request) {
  const parsedArgs = qs.parse(new URL(request.url).searchParams.toString(), {
    defaults: defaults,
    parsers: parsers,
  });

  parsedArgs.filter = { relid: { eq: "client" } };

  return parsedArgs;
}

export async function loader({ request }) {
  const args = graphqlArgs(request);

  return api.loadHistory(args, api.contextFromRequest(request));
}

const actions = {
  I: "Vytvoření",
  U: "Úprava",
  T: "Smazání",
  D: "Smazání",
};

export default function History() {
  const loaderData = useLoaderData();
  const auditConnection = loaderData.data.audit;

  return (
    <>
      <Card>
        <CardContent>
          <Typography sx={{ mb: 1 }} variant="h1">
            Historie změn
          </Typography>
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Datum</TableCell>
                  <TableCell>Uživatel</TableCell>
                  <TableCell>Typ</TableCell>
                  <TableCell>Akce</TableCell>
                  <TableCell>Stará data</TableCell>
                  <TableCell>Upravená data</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {auditConnection.data.map((row) => (
                  <TableRow key={row.id}>
                    <TableCell>
                      {f.date(d.parseUtcDateTime(row.created_at))}
                    </TableCell>
                    <TableCell>{row.user_name}</TableCell>
                    <TableCell>{row.relid}</TableCell>
                    <TableCell>{actions[row.action] ?? row.action}</TableCell>
                    <TableCell>
                      <RowData audit={row} />
                    </TableCell>
                    <TableCell>
                      <ChangedFields audit={row} />
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-end",
            }}
          >
            <TablePagination connection={auditConnection} component="div" />
          </Box>
        </CardContent>
      </Card>
    </>
  );
}
